import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import type { IntegrationSettings } from "common/types";

async function getIntegrationSettings(
  workspaceId: string,
): Promise<IntegrationSettings> {
  return (await get(`workspaces/${workspaceId}/integrations`)).integrations;
}

export default function useIntegrationSettings() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: integrationSettings, isLoading: isLoadingIntegrationSettings } =
    useQuery({
      queryKey: getQueryKeys(workspaceId).integrationSettingsKey,
      queryFn: () => getIntegrationSettings(workspaceId),
    });

  return { integrationSettings, isLoadingIntegrationSettings };
}
